module.exports = __webpack_public_path__ + "static/img/publicity-btn2.3d998b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/publicity-btn2.png
// module id = F0lu
// module chunks = 1